import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { getRowIdFromSecondaryMarketProduct } from 'state/secondaryMarket/productSearch/productSearch.utils';

import { ConnectedButtonsPanel } from './buttons';
import { ButtonPanelSkeleton } from './buttons/ButtonPanel.skeleton';
import { GridItems } from './GridItems';
import { ListItems } from './listItems';
import type { ModalContentProps } from './ProductSummaryModal.connect';

export const ProductSummaryModal: FC<ModalContentProps> = ({
  isOpen,
  onClose,
  onToggleOpen,
  data,
  isRefreshing,
  hasRefreshButton,
  onRefresh,
}) => {
  const rowId = isDefined(data) ? getRowIdFromSecondaryMarketProduct(data) : undefined;

  return (
    <Modal show={isOpen} onHide={onToggleOpen} centered>
      <div className="modal-header  align-items-center">
        <h3 className="modal-title flex-grow-1">
          <FormattedMessage id="secondaryMarket.modal.title" />
        </h3>
        {hasRefreshButton && (
          <Tooltip
            position="top"
            contents={<FormattedMessage id="secondaryMarket.modal.refreshButtons" />}
            color="secondary"
          >
            <button type="button" className="btn  btn-flat-secondary" onClick={onRefresh} disabled={isRefreshing}>
              <em className="icon">settings_backup_restore</em>
            </button>
          </Tooltip>
        )}
        <Tooltip position="top" contents={<FormattedMessage id="close" />} color="secondary">
          <button
            aria-label="Close"
            data-dismiss="modal"
            type="button"
            className="btn  btn-flat-secondary"
            data-e2e="product-summary-close-button"
            onClick={onClose}
          >
            <em className="icon">close</em>
          </button>
        </Tooltip>
      </div>
      <div className="modal-body pb-0">
        {isDefined(data) && <GridItems data={data} />}
        {isDefined(data) && <ListItems data={data} />}
      </div>
      <div className="modal-footer pt-0">
        {rowId !== undefined && !isRefreshing ? <ConnectedButtonsPanel rowId={rowId} /> : <ButtonPanelSkeleton />}
      </div>
    </Modal>
  );
};

ProductSummaryModal.displayName = 'ProductSummaryModal';
